import React,{useState , useEffect} from 'react'
import { useParams } from 'react-router-dom';
import $ from 'jquery';

function AttendanceReport() {
    const { date } = useParams();
    const [data, setGetData] = useState([])
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [checkedItems, setCheckedItems] = useState({});
    const [editableRow, setEditableRow] = useState(null);
    const existingHeaders = [
        { key: "empCode", value: "Emp Code", readOnly:true   },
        { key: "empName", value: "EMP Name" },
        { key: "ClientID", value: "Organization ID" },
        { key: "UnitID", value: "Branch ID" },
        { key: "JoiningDate", value: "Joining Date" },
        { key: "current_month", value: "Current Month" },
      ];
      const generateMonthHeaders = (year, month) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const monthIndex = month - 1; // Convert to zero-based index
        const lastDay = new Date(year, month, 0).getDate();

        const headers = [];
        for (let day = 1; day <= lastDay; day++) {
          const dayString = day.toString().padStart(2, '0');
          headers.push({ key: dayString, value: `${monthNames[monthIndex]}-${dayString}` });
        }

        return headers;
      };

      const [year, month] = date.split('-').map(part => parseInt(part, 10));
      const dateHeaders = generateMonthHeaders(year, month);
      const header = [...existingHeaders, ...dateHeaders];

    //   console.log(allHeaders);
      const handleSearchClick = (e) => {
        e.preventDefault();
        const value = $('#searchInput').val().toLowerCase();
        $('#dataTable tbody tr').each(function() {
        const rowText = $(this).text().toLowerCase();
        const isVisible = rowText.includes(value);
        $(this).toggle(isVisible);
        });
    };
    const handleCheckAll = () => {
        const newCheckedItems = { ...checkedItems };
        const visibleRows = $('#dataTable tbody tr:visible');

        const allVisibleChecked = visibleRows.toArray().every(row => {
            const id = $(row).data('id');
            return checkedItems[id];
        });

        const shouldCheck = !allVisibleChecked;

        visibleRows.each(function () {
            const id = $(this).data('id');
            newCheckedItems[id] = shouldCheck;
        });

        setCheckedItems(newCheckedItems);
    };
      const handleCheckChange = (id) => {
        setCheckedItems(prevCheckedItems => ({
          ...prevCheckedItems,
          [id]: !prevCheckedItems[id]
        }));
      };
      const calculateWidth = (text) => {
        const charWidth = 10;
        return `${text.length * charWidth}px`;
      };
      const [editedValues, setEditedValues] = useState({})
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditedValues({
          ...editedValues,
          [name]: value,
        });
      };
  return (
    <div>
          <div className="col-md-12 py-3">
            <div className="card">
                <div className="card-header card-header-color py-0">
                    <div className="col-md-12">
                        <div className="row client-form-header ">
                            <div className="col-md-6 pt-2">
                                <h6 className='text-dark'>Attendance Register</h6>
                            </div>
                            <div className="col-md-6">
                                <a href="/uploadform" className='text-dark'><i className="bi bi-x float-end cancel-icon"></i></a>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">
                        {/* <div className="col-md-6 mb-3">
                            <button
                                className="btn btn-info btn-sm text-white me-3"
                                // onClick={() => setuploadVisible(!uploadFormVisible)}
                                >
                                <b>Import Override for Attendance Register</b>
                            </button>
                        </div> */}
                        <div className="col-md-6 mb-3">
                            <a className="btn btn-success btn-sm float-md-end" href={`/uploadform/attendance_master/attendanceReport/${date}`}>
                                Generate Attendance Report
                            </a>
                        </div>
                        <div className="col-md-12">

                            <div className="row justify-content-between">
                                <div className="col-md-7">

                                </div>
                                <div className="col-md-5 ">
                                    <div className="row ">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12 justify-content-end">
                                                        <div className="col-md-4 d-flex search-div float-end">
                                                        <input
                                                            type="text"
                                                            placeholder="Search..."
                                                            id="searchInput"
                                                        />
                                                        <button onClick={handleSearchClick} className='search-submit'><i className="bi bi-search"></i></button>
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* {uploadFormVisible && (
                                <div className='col-md-5'>
                                <div className="row">
                                    <div className="card p-0 m-3">
                                        <div className="card-header pe-0 ">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col-md-10">
                                                        <h6>Import {title} file</h6>
                                                    </div>
                                                    <div className="col-md-2 float-end cursor-pointer pe-4">
                                                        <i  className="bi bi-x float-end p-0" onClick={() => setuploadVisible(!uploadFormVisible)}></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-3">
                                                <label for="formFile" className="form-label"><b>Import File</b></label>

            <a href={filestemp} download="file.xlsx" className='float-end'>
                template
            </a>
                                                <input className="form-control" type="file" id="formFile" onChange={handleFileChange} accept=".xls,.xlsx"/>
                                            </div>
                                            <div className='float-end'>
                                                <button className='btn btn-success btn-sm' onClick={handleFileUploaddata} type='submit'>Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            )} */}
                            </div>
                            <div className="card mt-4">
                            {/* onSubmit={handledeletemultialert} */}
                                <form >
                                    <div className="card-header">
                                        <div className="col-md-12">
                                            <div className="row justify-content-sm-between">
                                                <div className="col-md-2">
                                                    <p className='pt-1 m-0 client-2nd-header-size'>Selected Entries: </p>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="row ">
                                                        <div className='col-md-6 pt-1 client-2nd-header-size m-0' >
                                                            <p className="col-md-12">
                                                            Total Entries: { data ? data.length : 0 }
                                                            </p>
                                                        </div>
                                                        <div className="dropdown col-md-6 p-0 ">
                                                            <button className="btn p-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i className="bi bi-three-dots-vertical"></i>
                                                            </button>
                                                            <ul className="dropdown-menu btn-z-indexer">
                                                                <li><button className="dropdown-item "type='submit'>Delete Selected</button></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body m-0 p-0">
                                        <div className="table-responsive">
                                                {data !== 0 && header !== 0 ?(
                                                    <table className='table table-bordered tablefontsize' id='dataTable'>
                                                        <thead>
                                                            <tr >
                                                                <th className='bg-light'><input type="checkbox" checked={isAllChecked} onChange={handleCheckAll} name="" id="" /></th>
                                                                <th className='slnowidth bg-light'><span>SL NO</span></th>
                                                                {header.map(headerItem => (
                                                                    <th key={headerItem.key } style={{ minWidth: calculateWidth(headerItem.value) }} className='bg-light'>{headerItem.value}</th>
                                                                ))}
                                                                {/* <th className='bg-light'>Action</th> */}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {data ? (
                                                                <>
                                                                {data.map((item, index) => (
                                                                    <tr key={index}  data-id={item.id}>
                                                                        <td><input type="checkbox" name="" id="" checked={checkedItems[item.id] || false} onChange={() => handleCheckChange(item.id)} /></td>
                                                                        <td>{index + 1}</td>
                                                                        {header.map(headerItem => (
                                                                            <td key={headerItem.key}>
                                                                                {editableRow === item.id ? (
                                                                                    <input
                                                                                        type={headerItem.input}
                                                                                        value={editedValues[headerItem.key]}
                                                                                        name={headerItem.key}
                                                                                        onChange={handleInputChange}
                                                                                        readOnly={header.readOnly}
                                                                                    />
                                                                                ):(
                                                                                    item[headerItem.key]
                                                                                )}
                                                                            </td>
                                                                        ))}
                                                                        {/* <td className='text-center'>
                                                                        {editableRow === item.id ? (
                                                                            <div className="d-flex justify-content-between">
                                                                            <span onClick={handleSavealert} className='btn p-0'><i className="bi bi-save-fill text-success auction-btn"></i></span>
                                                                            <span onClick={handleCancelClick} className='btn p-0'><i className="bi bi-x-circle text-info auction-btn"></i></span>
                                                                            </div>
                                                                        ) : (
                                                                            <div className="d-flex justify-content-between">
                                                                            <span onClick={() => handleEditClick(item.id)} className='btn p-0'><i className="bi bi-pencil-square text-info auction-btn"></i></span>
                                                                            <span onClick={() => handledeletealert(item.id)} className='btn p-0'><i className="bi bi-trash3-fill text-danger auction-btn"></i></span>
                                                                            </div>
                                                                        )}
                                                                        </td> */}
                                                                    </tr>
                                                                ))}
                                                                </>
                                                            ):(
                                                                <tr>
                                                                    no data
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                ):(
                                                    <h1>no data</h1>
                                                )}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                            {/* <Dialog
                                open={openeditalert}
                                TransitionComponent={Transition}
                                keepMounted
                                aria-describedby="alert-dialog-slide-description"
                            >
                                <DialogTitle>{"Are you sure?"}</DialogTitle>
                                <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                Are you sure you want to edit this {title}? Any unsaved changes might be lost.
                                </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={handleCloseeditalert}>No</Button>
                                <Button onClick={handleSaveClickconfirmed}>Yes</Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={opendeletealert}
                                TransitionComponent={Transition}
                                keepMounted
                                aria-describedby="alert-dialog-slide-description"
                            >
                                <DialogTitle>{"Are you sure?"}</DialogTitle>
                                <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                Are you sure you want to delete this {title}? This action cannot be undone.

                                </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={handledeleteClosealert}>No</Button>
                                <Button onClick={handledeleteClickconfirmed}>Yes</Button>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={opendeletemultialert}
                                TransitionComponent={Transition}
                                keepMounted
                                aria-describedby="alert-dialog-slide-description"
                            >
                                <DialogTitle>{"Are you sure?"}</DialogTitle>
                                <DialogContent>
                                <DialogContentText id="alert-dialog-slide-description">
                                Are you sure you want to delete those {title}? This action cannot be undone.

                                </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={handledeletemultiClosealert}>No</Button>
                                <Button onClick={selectedDelete}>Yes</Button>
                                </DialogActions>
                            </Dialog> */}
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default AttendanceReport
